module.exports = __webpack_public_path__ + "img/email-white.20cf3e73.svg";